import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

function Confirmation() {
  return (
    <>
      <section
        className="company-bilerplate-sc"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          backgroundColor: "#F5F5F5",
        }}
      >
        <Container
          style={{
            maxWidth: "800px",
            backgroundColor: "white",
            minHeight: "30vh",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            padding: "30px",
          }}
        >
          <Row>
            <Col sm={12}>
              <p className="font-bio">
                Please note that you are being re-directed to an older version
                of our website. This website does NOT contain the latest updated
                information about our Products etc. Also note that the older
                website may not be fully compatible with certain browsers /
                devices.
              </p>

              <p className="font-bio">
                To visit the older version of the website click Continue. To
                remain on the current updated website click Close.
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ fontWeight: "bold" }}
                  href="https://prev.jmfinancialmf.com/"
                  aria-label="click here to go company confirmation continue button"
                >
                  Continue
                </Button>
                <Button
                  variant="danger"
                  style={{ fontWeight: "bold" }}
                  href="/"
                  aria-label="click here to close button"
                >
                  Close
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Confirmation;
